import { SetStateAction, useEffect, useState } from "react";
import { ListarEmpreendimentosController } from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import UnForm from "../../../../Components/Form";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { LiberacaoCasosVistoriaEmMassaController } from "../../../../Controllers/Vistorias/GestaoDeVistorias/GestaoDeVistoriasControllers";
import { IGestaoVistoriaResponse } from "../../../../Interfaces/Vistorias/VistoriaEntregaDeChaves/GestaoDeEntregaChaves";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";

interface ILiberarCasosVistoriaProps {
    setShow: (value: SetStateAction<boolean>) => void;
    updateList: (...args: any[]) => Promise<IGestaoVistoriaResponse>;
}

export default function LiberarCasosVistoria(
    props: ILiberarCasosVistoriaProps
) {
    const {
        execute: LiberacaoCasosVistoriaEmMassa,
        loading: LiberacaoCasosVistoriaEmMassaLoading,
    } = useAsyncCallback(LiberacaoCasosVistoriaEmMassaController);

    function handleLiberarCasosVistoria(formData: any) {
        LiberacaoCasosVistoriaEmMassa(formData.ID_EMPREENDIMENTO.value).then(
            () => {
                props.setShow(false);
                props.updateList();
            }
        );
    }

    const [options, setOptions] = useState<
        Array<{ value: number; label: string }> | undefined
    >();

    const { value: lstEmpreendimentos } = useAsyncEffect(
        () => ListarEmpreendimentosController(),
        []
    );

    useEffect(() => {
        setOptions(() =>
            lstEmpreendimentos?.map((empreendimento) => ({
                label: empreendimento.DS_EMPREENDIMENTO,
                value: empreendimento.ID_EMPREENDIMENTO,
            }))
        );
    }, [lstEmpreendimentos]);

    return (
        <UnForm handleSubmit={handleLiberarCasosVistoria}>
            <div className="col-12 mt-3">
                <label>Empreendimento</label>
                <UnForm.SelectComBusca
                    name="ID_EMPREENDIMENTO"
                    options={options}
                />
            </div>

            <UnForm.SubmitButton
                color="success"
                icon={faCheck}
                className="w-100 mt-3"
                disabled={LiberacaoCasosVistoriaEmMassaLoading}
                loading={LiberacaoCasosVistoriaEmMassaLoading}
                loadingSize="sm"
            >
                Liberar Casos
            </UnForm.SubmitButton>
        </UnForm>
    );
}
